import { useMemo } from 'react';

import { PaginationParams } from '@/common/types';
import { useCurrentOrganization } from '@/modules/core/hooks';

import { useGetProcessingRuleByIdQuery, useProcessingRulesQuery } from '../queries';

interface Props {
  isViewMode?: boolean;
  ruleId?: string;
  isUsed?: boolean;
  linkedRuleId?: string;
}

export default (params?: PaginationParams, props?: Props, enabled = true) => {
  const { observingOrganization } = useCurrentOrganization();

  const { data, isLoading, total, list, isFetching } = useProcessingRulesQuery(
    observingOrganization.path,
    props?.isUsed,
    params,
    enabled && !props?.isViewMode
  );
  const {
    rule,
    isLoading: isRuleLoading,
    isFetching: isRuleFetching,
    ruleOption,
  } = useGetProcessingRuleByIdQuery(props?.ruleId, enabled);

  const currentRules = useMemo(() => (props?.isViewMode ? [rule] : data), [props?.isViewMode, rule, data]);
  const currentOptions = useMemo(
    () => (props?.isViewMode ? ruleOption : list),
    [props?.isViewMode, ruleOption, list]
  );

  return {
    total,
    currentRule: rule,
    data: currentRules || [],
    list: currentOptions || [],
    isLoading: isLoading || isRuleLoading,
    isFetching: isFetching || isRuleFetching,
  };
};
